import * as tslib_1 from "tslib";
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var NpsService = /** @class */ (function () {
    function NpsService(http) {
        this.http = http;
        this.getUrl = environment.THE_MIRROR_URL + "/nps/cmms/responses/latest";
        this.postUrl = environment.THE_MIRROR_URL + "/nps/cmms/responses";
    }
    NpsService.prototype.getNps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_1, error;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.http.get(this.getUrl).toPromise()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_1 = _a.sent();
                        error = err_1;
                        if (error.status === 404) {
                            return [2 /*return*/, null];
                        }
                        throw err_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NpsService.prototype.postNps = function (value, comment) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.post(this.postUrl, { value: value, comment: comment }).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NpsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NpsService_Factory() { return new NpsService(i0.ɵɵinject(i1.HttpClient)); }, token: NpsService, providedIn: "root" });
    return NpsService;
}());
export { NpsService };
